import { createFileRoute } from "@tanstack/react-router";
import { OnboardingOverview } from "@/components/sites/onboarding-overview";
import { useOnboardingProgress } from "@/components/sites/use-onboarding-progress";

export const Route = createFileRoute("/dashboard/onboarding/")({
  component: OnboardingPage,
  // No title: the layout route above already contributes "Onboarding" to the
  // breadcrumb, and a matching one here would render it twice.
  staticData: {},
});

function OnboardingPage() {
  const { siteName, registerTotal, steps, status } = useOnboardingProgress();

  return (
    <OnboardingOverview
      siteName={siteName}
      registerTotal={registerTotal}
      steps={steps}
      status={status}
    />
  );
}
